module.exports = __webpack_public_path__ + "img/background-1.ad1fbac7.png";